import {ReportData} from "../../../reports/report.data";
import {dateField, field, LocalisableEntityData} from "@fedeltapointofsale/data-client";

export class SalesByHalfHourReportData extends LocalisableEntityData<SalesByHalfHourReportData> {
    @field exclusive: boolean = true;
    @field reportType: string = "Report By Week";
    @dateField singleDate: Date = this.getDefaultDate();

    getDefaultDate(): Date {
        const defaultDate: Date = new Date();
        defaultDate.setHours(0);
        defaultDate.setMinutes(0);
        return defaultDate;

    }
}
